var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRisLiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,8.7c-1.6,0-3,1.3-3,3c0,1.6,1.3,3,3,3s3-1.3,3-3C15,10,13.6,8.7,12,8.7z M12,12.6c-0.5,0-1-0.4-1-1s0.4-1,1-1 s1,0.4,1,1S12.5,12.6,12,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6,6.8c-0.4-0.4-1-0.4-1.4,0c-2.7,2.7-2.7,7,0,9.7c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4 c-1.9-1.9-1.9-5,0-6.9C9,7.8,9,7.2,8.6,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2,11.6c0-2.3,0.9-4.5,2.6-6.2c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0c-2,2-3.2,4.7-3.2,7.6c0,2.9,1.1,5.6,3.2,7.6 c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4C4.1,16.2,3.2,14,3.2,11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,6.8c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4c0.9,0.9,1.4,2.1,1.4,3.4c0,1.3-0.5,2.5-1.4,3.4c-0.4,0.4-0.4,1,0,1.4 c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c1.3-1.3,2-3,2-4.9C18.9,9.8,18.1,8.1,16.8,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6,4c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4c3.4,3.4,3.4,9,0,12.4c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3 s0.5-0.1,0.7-0.3C23.8,15.1,23.8,8.2,19.6,4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisLiveIcon);
export default __webpack_public_path__ + "static/media/RISLiveIcon.580a5c905d92d84e07b66e5ea59cd20a.svg";
export { ForwardRef as ReactComponent };